import Component from './forgotten-pass'

export default Component